import IndexModel from "@/service/v1/sigap/IndexModel";
 
class FeriadoService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Feriado' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    

    
    public getNiveis( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetNiveis'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public getTipos( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipos'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
}
  
export default FeriadoService;

